module.exports = __webpack_public_path__ + "img/MONTAJE.62400dac.png";